export default __webpack_public_path__ + "static/media/image.7ce7558d.svg";